import React, { useState, useEffect } from 'react';

// mui
import {
    Box,
    Divider,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    IconButton,
    Slide,
    Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';

// icons
import {
    AccountCircle as AccountCircleIcon,
    AccountCircleOutlined as AccountCircleOutlinedIcon,
    DisplaySettings as DisplaySettingsIcon,
    DisplaySettingsOutlined as DisplaySettingsOutlinedIcon,
    ChatBubbleOutlined as ChatBubbleOutlinedIcon,
    ChatBubbleOutlineOutlined as ChatBubbleOutlineOutlinedIcon,
    Info as InfoIcon,
    InfoOutline as InfoOutlineIcon,
    ChevronRight as ChevronRightIcon,
    ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';

import { TabList, TabContext, TabPanel } from '@mui/lab';

// components
import { SettingAccount, SettingAccountChangePassword, SettingsAccountMfa } from '..';

// api
import {} from '../../api';

// state
import { storage } from '@goldblack/client-storage';

function AdminSettings(props) {
    const [value, setValue] = useState('1');
    const [selectedTab, setSelectedTab] = useState(null);
    const [hoveredTab, setHoveredTab] = useState(null);
    const [hasInteracted, setHasInteracted] = useState(false);
    const [accountSubViewActive, setAccountSubViewActive] = useState(false);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setSelectedTab(newValue);
        if (!hasInteracted) {
            setHasInteracted(true);
        }
    };

    const handleBack = () => {
        setSelectedTab(null);
    };

    const settingTabs = [
        {
            value: '1',
            label: 'Account',
            icon: AccountCircleOutlinedIcon,
            selectedIcon: AccountCircleIcon,
            body: <SettingAccount {...props} onSubViewChange={setAccountSubViewActive} onBack={handleBack} />,
        },
    ];

    const currentTab = settingTabs.find((tab) => tab.value === selectedTab);

    return (
        <Box sx={{ height: '92vh', position: 'relative', overflow: 'hidden' }}>
            <Slide direction='right' in={!selectedTab} timeout={hasInteracted ? 300 : 0} mountOnEnter unmountOnExit>
                <Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            py: 3,
                        }}>
                        <Typography align='center' variant='m_titleL' color='primary.main' sx={{ mb: 0.5 }}>
                            GoldBlack Admin
                        </Typography>
                    </Box>
                    <List sx={{ width: '100%', pt: 0 }}>
                        {settingTabs.map((tab, index) => {
                            const isSelected = value === tab.value;
                            const isHovered = hoveredTab === tab.value;
                            const IconComponent = isSelected || isHovered ? tab.selectedIcon : tab.icon;
                            return (
                                <Box key={tab.value}>
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            onClick={() => handleChange(null, tab.value)}
                                            onMouseEnter={() => setHoveredTab(tab.value)}
                                            onMouseLeave={() => setHoveredTab(null)}>
                                            <ListItemIcon sx={{ minWidth: 40, color: 'primary.main' }}>
                                                <IconComponent />
                                            </ListItemIcon>
                                            <ListItemText primary={tab.label} sx={{ color: 'text.primary' }} />
                                            <ChevronRightIcon sx={{ color: 'primary.main' }} />
                                        </ListItemButton>
                                    </ListItem>
                                    {index < settingTabs.length - 1 && (
                                        <Divider
                                            variant='middle'
                                            component='li'
                                            sx={{
                                                borderColor: (theme) => alpha(theme.palette.primary.main, 0.25),
                                            }}
                                        />
                                    )}
                                </Box>
                            );
                        })}
                    </List>
                </Box>
            </Slide>

            <Slide direction='left' in={!!selectedTab} timeout={300} mountOnEnter unmountOnExit>
                <Box>
                    {!(selectedTab === '1' && accountSubViewActive) && (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                px: 1,
                                py: 0.5,
                                minHeight: 48,
                            }}>
                            <IconButton onClick={handleBack} size='small'>
                                <ArrowBackIcon />
                            </IconButton>
                        </Box>
                    )}
                    <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>{currentTab?.body}</Box>
                </Box>
            </Slide>
        </Box>
    );
}

export { AdminSettings };
